<template>
  <div>
    <div class="row margin-t-s margin-b-m">
      <div class="payment-form showhide-fadeslide column">
        <div>
          <div class="row">
            <div class="medium-12 columns">
              <label class="field-label">Card Info</label>
              <div id="card-element"></div>
            </div>
          </div>

          <div class="row">
            <div class="medium-12 columns">
              <div v-bind:class="['field-group' + (validation.cardName? '': ' field-error')]">
                <label class="field-label">Cardholder Name</label>
                <input class="field-text" type="text" v-model:bind="card.name"
                  placeholder="i.e. John Appleseed" />
                <label class="field-error-message">
                  {{ $t('payment.isRequired') }}
                </label>
              </div>
            </div>
                  
            <div class="medium-12 columns small-padding-h-z">
              <div v-bind:class="['field-group' + (validation.cardAddress? '': ' field-error')]">
                <label class="field-label">Billing Address</label>
                <input class="field-text" type="text" v-model:bind="card.billingAddress" :disabled="loading" />
                <label class="field-error-message">{{ $t('payment.isRequired') }}</label>
              </div>
            </div>
            <div class="small-6 columns padding-r-s small-padding-r-z small-padding-r-s">
              <div v-bind:class="['field-group' + (validation.cardCity? '': ' field-error')]">
                <label class="field-label">City</label>
                <input class="field-text" type="text" v-model:bind="card.billingCity" />
                <label class="field-error-message">{{ $t('payment.isRequired') }}</label>
              </div>
            </div>

            <div class="small-6 columns padding-l-s small-padding-l-z small-padding-l-s">
              <div v-bind:class="['field-group' + (validation.cardState? '': ' field-error')]">
                <label class="field-label">{{ $t('payment.state') }}</label>
                <select class="field-select field-text" v-model="card.billingState" v-on:change="onStateSelect" :disabled="loading">
                  <option disabled value="-1">{{ $t('payment.chooseOne') }}</option>
                  <option v-for="state in states" v-bind:value="state.value">{{ state.name }}</option>
                </select>
                <label class="field-error-message">{{ $t('payment.isRequired') }}</label>
              </div>
            </div>
            <div v-bind:class="['small-12 columns small-padding-a-n' + (showCountry? '': ' hide')]">
              <div v-bind:class="['field-group' + (validation.cardCountry? '': ' field-error')]">
                <label class="field-label">{{ $t('payment.country') }}</label>
                <select class="field-select field-text" v-model="card.billingCountry" :disabled="loading">
                  <option disabled value="-1">{{ $t('payment.chooseOne') }}</option>
                  <option v-for="country in countries" :value="country.value">{{ country.name }}</option>
                </select>
                <label class="field-error-message">{{ $t('payment.isRequired') }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="clear"></div>

      <div v-bind:class="['alert-wrap showhide-fadeslide column' + (showCreditCardError ? '':' hide')]">
        <div class="small-12 columns">
          <div class="alert error margin-t-m">{{ creditCardError }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* global CONFIG */
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import US from 'us'
import Countries from '@/data/countries.js'

Vue.use(VueCookie)

export default {
  name: 'stripe-payment-form',
  data () {
    return {
      loading: false,
      showCountry: false,
      creditCardError: '',
      showCreditCardError: false,
      validation: {
        cardName: true,
        cardAddress: true,
        cardCity: true,
        cardState: true,
        cardCountry: true
      },
      card: {
        cardName: '',
        billingAddress: '',
        billingCity: '',
        billingState: '-1',
        billingCountry: '-1'
      },
      stripe: null,
      cardElement: null
    }
  },
  computed: {
    states () {
      let result = []
      result.push({
        name: 'Non US',
        value: ''
      })
      let states = US.STATES
      for (let i = 0; i < states.length; i++) {
        result.push({
          name: states[i].name,
          value: states[i].abbr
        })
      }
      return result
    },
    countries () {
      let result = []
      for (let property in Countries) {
        if (!Countries.hasOwnProperty(property)) { continue }
        if (property === 'us') { continue }
        result.push({
          name: Countries[property].name,
          value: property.toUpperCase()
        })
      }
      return result
    },
    selectedPayment () { return this.$store.state.selectedCard.id },
    bookingType () { return this.$store.state.reservation.bookingType }
  },
  methods: {
    clearValidation () {
      this.validation.cardAddress = true
      this.validation.cardCity = true
      this.validation.cardState = true
      this.validation.cardCountry = true
    },
    validatePaymentForm () {
      let self = this
      let card = self.card
      let result = true;

      self.clearValidation()

      if (card.billingAddress === '') {
        self.validation.cardAddress = false
        result = false
      }

      if (card.billingCity === '') {
        self.validation.cardCity = false
        result = false
      }

      if (card.billingState === '-1') {
        self.validation.cardState = false
        result = false
      }

      if (card.billingState === '' && card.billingCountry === '-1') {
        self.validation.cardCountry = false
        result = false
      }

      return result
    },
    submitPayment () {
      let self = this
      if (self.validatePaymentForm()) {
        self.loading = true
        self.$sdk.post(self, '/me/cards/setup', {
          token: self.$store.state.user.token
        }, res => {
          if (res.error) {
            self.loading = false
            self.showCreditCardError = true
            self.creditCardError = res.error.message
            self.$emit('failed')
            self.$store.commit('global/setLoaderData', {show: true})
            return
          }

          let state = self.card.billingState
          let country = 'US'
          if (state === '') {
            country = self.card.billingCountry
          }
          self.stripe.confirmCardSetup(res.client_secret, {
            payment_method: {
              card: self.cardElement,
              billing_details: {
                name: self.card.name,
                address: {
                  city: self.card.billingCity,
                  country: country,
                  line1: self.card.billingAddress,
                  state: state
                }
              }
            }
          }).then(result => {
            // console.log('confirm_setup', result)
            if (result.error) {
              self.loading = false
              self.showCreditCardError = true
              self.creditCardError = result.error.message
              self.$emit('failed')
              self.$store.commit('global/setLoaderData', {show: false})
              return
            }
            self.addCard(result)
          })
        })
      } else {
        self.$emit('failed')
      }
    },
    addCard (result) {
      let self = this
      self.$sdk.post(self, '/me/cards/token', {
        token: self.$store.state.user.token,
        paymentMethodId: result.setupIntent.payment_method
      }, r => {
        self.loading = false
        if (r.error) {
          self.$store.commit('global/setLoaderData', {show: false})
          self.loading = false
          self.showCreditCardError = true
          self.creditCardError = r.error.message
          self.$emit('failed')
          return
        }
        // console.log('card/token', r)
        let card = r.cards[0]
        self.$store.commit('setSelectedCard', {
          id: card.ID,
          type: card.title,
          number: card.cardNumber,
          exp: card.cardExpires,
          className: self.parseCardClass(card)
        })
        if (['flight', 'sightSeeing', 'hotel'].indexOf(self.bookingType) > -1) {
          self.$emit('done')
          // self.$root.$router.push('review-summary')
        } else {
          self.$root.$router.push('review')
        }
      })
    },
    parseCardClass (card) {
      let result = ''
      if (card.title === 'Visa') result = 'visa'
      else if (card.title === 'MasterCard' || card.title === 'Master Card') result = 'mastercard'
      else if (card.title === 'American Express') result = 'amex'
      else if (card.title === 'JCB') result = 'jcb'
      else if (card.title === 'Diners Club') result = 'dinersclub'
      else if (card.title === 'Discover') result = 'discover'

      return result
    },
    onStateSelect () {
      this.showCountry = this.card.billingState === ''
      if (this.showCountry) {
        this.card.billingCountry = '-1'
      }
    },
    clearFields () {
      this.card = {
        cardName: '',
        billingAddress: '',
        billingCity: '',
        billingState: '-1',
        billingCountry: '-1'
      }
      this.cardElement.clear()
    }
  },
  watch: {
    loading (val) {
      this.cardElement.update({disabled: val})
    }
  },
  mounted () {
    this.stripe = Stripe(CONFIG.stripe.publishableKey) // eslint-disable-line
    let elements = this.stripe.elements({
      fonts: [{cssSrc: 'https://fonts.googleapis.com/css2?family=Questrial&display=swap'}]
    })
    this.cardElement = elements.create('card')
    this.cardElement.mount('#card-element')
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/CreditCardIcons.css";
@import "../../assets/scss/CreditCardIcons.scss";
@import "../../assets/scss/Payment/PaymentForm.scss";
h2{ font-size: 1.5em!important; }
.fa-icon {
  width: auto;
  height: 1em; /* or any other relative font sizes */
}
.op-btn, .op-btn:not(.loading) .original-label{ display: inline-flex!important; } /* cross browser fix */
.alert-wrap{
  width: 100%;
}

#card-element{
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 15px;
  background: #fbfbfb;
  box-shadow: inset 1px 1px 2px rgba(0,0,0,.1);
}
</style>



// WEBPACK FOOTER //
// StripePaymentForm.vue?fb3f41ba